import React, { Component } from 'react';
import './styles/RMSSelectSyringeDriver.css';
import backIcon from './images/backIcon.png';
import VersionService from './VersionService';

class RMSSelectSyringeDriver extends Component {
  constructor(props) {
    super(props);

    const rows = [
      {
        id: 1,
        title: 'Freedom60',
        header: false,
        value: 1,
        syringeSource: require('./images/FREEDOM60-BW-vector.png'),
        syringeLabelImage: require('./images/FREEDOM60-logo.png'),
        style: {
          marginTop: 5,
          width: '45%',
        },
      },
      {
        id: 2,
        title: 'Freedom EDGE 20ML Syringe',
        header: false,
        value: 1,
        syringeSource: require('./images/FreedomEdge-20ml.png'),
        syringeLabelImage: require('./images/FreedomEdge-20ml-logo.png'),
        style: {
          marginTop: 0,
          width: '60%',
        },
      },
      {
        id: 3,
        title: 'Freedom EDGE 30ML Syringe',
        header: false,
        value: 0.78,
        syringeSource: require('./images/FreedomEdge-30ml.png'),
        syringeLabelImage: require('./images/FreedomEdge-30ml-logo.png'),
        style: {
          marginTop: 0,
          width: '60%',
        },
      },
    ];

    this.state = {
      rows: rows,
    };
  }

  syringeSelected = (item) => {
    this.props.setSelectedSyringe(item);
    this.props.changePage('RMSSelectDrug');
  };

  render() {
    var linkItems = this.state.rows.map((item) => {
      // if (
      //   item.id === 3 &&
      //   VersionService.getVersionCode() === 'international'
      // ) {
      //   return;
      // }
      return (
        <div
          key={item.id}
          className={`${
            VersionService.getVersionCode() === 'international'
              ? 'col-lg-4'
              : 'col-lg-4'
          } col-xs-12 syringe-list`}
        >
          <a onClick={() => this.syringeSelected(item)}>
            <div>
              <img src={item.syringeSource} alt={item.title} />
            </div>
            <div>
              <img
                style={item.style}
                src={item.syringeLabelImage}
                alt={item.title}
              />
            </div>
            {/*<div className="syringe-list-label">*/}
            {/*<span>*/}
            {/*{item.title}*/}
            {/*</span>*/}
            {/*</div>*/}
          </a>
        </div>
      );
    });
    return (
      <div className="row">
        <div className="col-lg-12 col-xs-12 syringe-wrapper">
          <div className="row">
            <div className="col-lg-12 col-xs-12 drug-title">
              <h4>
                <img
                  className="backbutton"
                  src={backIcon}
                  alt="Go Back"
                  onClick={() =>
                    this.props.changePage('VersionSelection')
                  }
                />
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-xs-12 syringe-title">
              <h4 className="page-title">Select Syringe Driver</h4>
              <h4 className="page-title">
                {VersionService.getVersionLabel()}
              </h4>
            </div>
          </div>
          <div className="row syringe-row">{linkItems}</div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-xs-12 mt-5 reference-hdr">
              <p>
                The calculator is intended for reference only. Always
                refer to the Instructions for Use for the infusion
                system and the{' '}
                {VersionService.getVersionCode() !== 'us'
                  ? 'medicinal product'
                  : 'drug'}
                /biologic prescribing information (PI) prior to using
                the device.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RMSSelectSyringeDriver;



// WEBPACK FOOTER //
// ./src/RMSSelectSyringeDriver.js